import React, { useEffect, useMemo, useState } from "react";
import SessionList from "../components/SessionList";

function todayYYYYMMDD() {
  // local date in YYYY-MM-DD
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

const SessionAnalyticsPage = () => {
  const [selectedId, setSelectedId] = useState(null);

  // ✅ pick a date to request sessions for (default = today)
  const [selectedDate, setSelectedDate] = useState(todayYYYYMMDD());

  // ✅ sessions returned by backend: array of session IDs (strings)
  const [sessions, setSessions] = useState([]);

  useEffect(() => {
    if (!selectedDate) return;

    fetch(`/api/chat/sessions/${selectedDate}`)
      .then((res) => res.json())
      .then((data) => {
        const ids = Array.isArray(data.sessions) ? data.sessions : [];
        // SessionList often expects objects, so map into { id }
        setSessions(ids.map((id) => ({ id })));
        // auto-select first session if none selected
        if (!selectedId && ids.length) setSelectedId(ids[0]);
      })
      .catch((err) => {
        console.error(err);
        setSessions([]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const selectedSession = useMemo(
    () => sessions.find((s) => s.id === selectedId) || null,
    [sessions, selectedId]
  );

  return (
    <div className="session-analytics-page">
      <h2>📊 Session Analytics</h2>

      {/* ✅ date picker so you can change which day's sessions you’re viewing */}
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: "inline-flex", gap: 8, alignItems: "center" }}>
          <span>Date</span>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </label>
      </div>

      <SessionList
        sessions={sessions}
        selectedId={selectedId}
        onSelect={(session) => setSelectedId(session.id)}
      />

      {/* Optional: shows what’s selected (safe even if SessionList is basic) */}
      {selectedSession && (
        <p style={{ marginTop: 12 }}>
          Selected session: <strong>{selectedSession.id}</strong>
        </p>
      )}
    </div>
  );
};

export default SessionAnalyticsPage;